<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top rounded-4 overflow-hidden border-0">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row g-2 align-items-start flex-nowrap p-2">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Manage Risk Framework Assessments</h1>
          </div>

          <div class="col-auto">
            <button
              type="button"
              class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end"
              data-bs-toggle="modal"
              data-bs-target="#create_risk_framework_modal"
              @click="open_create_modal"
            >
              <i class="bi bi-plus-circle-fill me-2 text-white"></i>
              Create Risk Framework
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2 mt-3">
      <div class="row g-2 align-items-start align-items-lg-center mb-3">
        <div class="col-12 col-lg">
          <div class="d-flex align-items-center gap-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
              <i class="bi bi-grid-3x3-gap-fill"></i>
            </div>
            <div>
              <div class="entity-section-title fw-bold fs-6">Active Risk Frameworks</div>
              <div class="text-secondary text-xxs">Showing configured risk frameworks pulled from the backend API.</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-auto">
          <div class="d-grid d-sm-flex align-items-stretch gap-2">
            <div class="input-group d-none d-md-flex">
              <span class="input-group-text bg-light border-0 rounded-start-pill">
                <i class="bi bi-search text-secondary"></i>
              </span>
              <input
                v-model.trim="search_query"
                type="text"
                class="form-control form-control-sm bg-light border-0 rounded-end-pill text-x"
                placeholder="Search Risk Framework..."
              />
            </div>

            <button
              type="button"
              class="btn btn-light btn-sm rounded-3"
              :class="filter_mode !== 'all' ? 'border-primary text-primary' : ''"
              :title="`Filter: ${filter_mode}`"
              @click="toggle_filter_mode"
            >
              <i class="bi bi-funnel"></i>
            </button>

            <button
              type="button"
              class="btn btn-light btn-sm rounded-3"
              :title="`Sort: ${sort_label()}`"
              @click="cycle_sort_mode"
            >
              <i class="bi bi-sliders"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="d-md-none mb-3">
        <div class="input-group">
          <span class="input-group-text bg-light border-0 rounded-start-pill">
            <i class="bi bi-search text-secondary"></i>
          </span>
          <input
            v-model.trim="search_query"
            type="text"
            class="form-control form-control-sm bg-light border-0 rounded-end-pill"
            placeholder="Search Risk Framework..."
          />
        </div>
      </div>

      <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-2">ID</div>
          <div class="col-lg-3">Risk Framework</div>
          <div class="col-lg-2">Type</div>
          <div class="col-lg-2">Description</div>
          <div class="col-lg-1">Status</div>
          <div class="col-lg-2 text-end">Actions</div>
        </div>
      </div>

      <div v-if="loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>Loading Risk Frameworks...</span>
      </div>

      <div v-else-if="paginated_frameworks.length" class="d-flex flex-column gap-2">
        <article
          v-for="framework in paginated_frameworks"
          :key="framework.id"
          class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
        >
          <div class="entity-row-layout row g-2 align-items-center">
            <div class="col-12 col-lg-2">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">ID</div>
              <span class="text-xs fw-semibold text-secondary">{{ format_framework_id(framework.frameworkId) }}</span>
            </div>

            <div class="col-12 col-sm-6 col-lg-3">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Risk Framework</div>
              <span class="fw-semibold risk-framework-name">{{ framework.title }}</span>
            </div>

            <div class="col-12 col-sm-6 col-lg-2">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Type</div>
              <span class="risk-framework-type-pill">{{ framework.type.toUpperCase() }}</span>
            </div>

            <div class="col-12 col-lg-2">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Description</div>
              <span class="risk-framework-description text-secondary d-block">{{ framework.description }}</span>
            </div>

            <div class="col-12 col-sm-6 col-lg-1">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Status</div>
              <span class="risk-framework-status d-inline-flex align-items-center gap-2">
                <span class="risk-framework-status-dot"></span>
                <span>{{ framework.status }}</span>
              </span>
            </div>

            <div class="col-12 col-sm-6 col-lg-2 d-flex justify-content-lg-end">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Actions</div>
              <div class="d-flex align-items-center gap-2 risk-framework-actions">
                <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="manage_framework(framework)">
                  Manage
                </button>
                <button type="button"class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="deactivate_framework(framework)">
                  Deactivate
                </button>
              </div>
            </div>
          </div>
        </article>
      </div>

      <div v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
        <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
          <i class="bi bi-shield-check fs-3"></i>
        </div>
        <div class="fw-bold mb-1">No risk frameworks found</div>
        <div class="text-secondary small">Create your first risk framework to start managing assessments.</div>
      </div>

      <div
        v-if="!loading && paginated_frameworks.length"
        class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 px-2 py-3"
      >
        <div class="text-secondary text-xs">{{ pagination_label }}</div>

        <nav aria-label="Risk framework pagination">
          <div class="d-inline-flex align-items-center rounded-3 border overflow-hidden bg-white">
            <button
              type="button"
              class="btn btn-sm btn-light border-0 rounded-0 px-2"
              @click="set_page(current_page - 1)"
              :disabled="current_page === 1"
              aria-label="Previous page"
            >
              <i class="bi bi-chevron-left"></i>
            </button>

            <button
              v-for="page in total_pages"
              :key="page"
              type="button"
              class="btn btn-sm rounded-0 border-0 border-start px-3 pagination-seg-btn"
              :class="page === current_page ? 'btn-primary-dark text-white' : 'btn-light'"
              @click="set_page(page)"
            >
              {{ page }}
            </button>

            <button
              type="button"
              class="btn btn-sm btn-light border-0 border-start rounded-0 px-2"
              @click="set_page(current_page + 1)"
              :disabled="current_page === total_pages"
              aria-label="Next page"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </nav>
      </div>
    </section>
  </div>
</div>

<teleport to="body">
  <div class="modal fade" id="create_risk_framework_modal" tabindex="-1" aria-labelledby="create_risk_framework_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg border-0 overflow-hidden">
        <div class="modal-header cute-header border-0 px-4 py-3">
          <p class="modal-title text-white fs-5 fw-semibold mb-0" id="create_risk_framework_modal_label">Create Risk Framework</p>
          <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <form @submit.prevent="create_risk_framework">
          <div class="modal-body px-4 py-4">
            <div class="d-flex flex-column gap-4">
              <div>
                <label class="modal-form-label text-xs fw-normal mb-2" for="framework_type">Select Risk Type</label>
                <select id="framework_type" v-model.number="create_form.risk_framework_type_id" class="form-select modal-form-control text-xs">
                  <option value="" disabled>Please select</option>
                  <option v-if="!risk_types.length" value="" disabled>Loading types...</option>
                  <option v-for="risk_type in risk_types" :key="risk_type.id" :value="risk_type.id">
                    {{ risk_type.risk_type }}
                  </option>
                </select>
              </div>

              <div>
                <label class="modal-form-label text-xs fw-normal mb-2" for="framework_title">Risk Name</label>
                <input
                  id="framework_title"
                  v-model.trim="create_form.risk_assessment"
                  type="text"
                  class="form-control modal-form-control text-xs"
                  placeholder="e.g. High Exposure"
                />
              </div>

              <div>
                <label class="modal-form-label text-xs fw-normal mb-2" for="framework_description">Risk Description</label>
                <textarea
                  id="framework_description"
                  v-model.trim="create_form.description"
                  class="form-control modal-form-control text-xs"
                  rows="3"
                  placeholder="Describe this framework"
                ></textarea>
              </div>

              <div>
                <label class="modal-form-label text-xs fw-normal mb-2" for="assessment_phase">Assessment Phase</label>
                <select id="assessment_phase" v-model.trim="create_form.assessment_phase" class="form-select modal-form-control text-xs">
                  <option value="" disabled>Please select</option>
                  <option value="pre">Pre-Assessment</option>
                  <option value="post">Post-Assessment</option>
                </select>
              </div>
            </div>
          </div>

          <div class="modal-footer border-top-0 px-4 pb-4 pt-0">
            <button type="submit" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1">Create Framework</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>
